import {UserRole, UserSession} from './models';

export const isUserPermittedForRole = (role: UserRole, session: UserSession): boolean =>
    session.roles.findIndex((el) => el === role) !== -1;

export const canAddMoreThan3MediaSections = (
    session: UserSession | undefined,
    currentNumberOfMediaSections: number,
) => {
    if (session) {
        const isPermitted = isUserPermittedForRole(UserRole.CAN_ADD_MULTIPLE_MEDIA_SECTIONS, session);
        if (isPermitted) {
            return true;
        } else {
            return currentNumberOfMediaSections <= 3;
        }
    } else {
        return false;
    }
};

export const canCreateCatalogSection = (session: UserSession | undefined): boolean => {
    if (session) {
        return isUserPermittedForRole(UserRole.CAN_ADD_CATALOG, session);
    } else {
        return false;
    }
};
